module.exports = __webpack_public_path__ + "static/media/impact_byte_logo.27df3a29.png";